<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <card>
                    <UserMessagesIncoming />
                </card>
            </b-col>
            <b-col xl="5">
                <card>
                    <UserMessageSend /> 
                </card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import UserMessagesIncoming from '@/components/Dispatching/UserMessagesIncoming'
import UserMessageSend from '@/components/Dispatching/UserMessageSend'

export default {
    components: {
        UserMessagesIncoming, UserMessageSend
    }    
}
</script>